import { createReducer, on } from '@ngrx/store';
import { castFormActions } from '../actions';

export const featureKey = 'cast-form';

export const initialState: any = {
    tab: 0
};

export const reducer = createReducer(
    initialState,
    on(castFormActions.setCurrTab, (state, { tab }) => ({ ...state, tab }))
);
